import { z } from 'zod';

export const createCodeSchema = z.object({
  curriculum: z.string().transform((s) => Number.parseInt(s, 10)),
  group: z.string().transform((s) => Number.parseInt(s, 10)),
  location: z.string().transform((s) => Number.parseInt(s, 10)),
  name: z.string().trim(),
});
